<script>
  import { timeStore } from '../../stores';
  import { config } from '../../../scripts/defaultURL';
  import { formatDate } from '../../../scripts/functions';
  import { postData } from '../../../scripts/rest';

  export let clientOptions;
  export let categoryOptions;
  
  let client_id;
  let payload = {
    date: formatDate(new Date())
  };

  function closeModal() {
    clearForm();
    document.getElementById('timeModal').classList.remove('is-active')
    if (!$timeStore) $timeStore = {};
    $timeStore['todo'] = 'getData';
  }

  function clearForm() {
    const inputs = document.querySelectorAll('input');
    for (let i=0; i < inputs.length; i++) {
      inputs[i].value = null;
    }
    payload = {
      date: formatDate(new Date())
    };
  }

  function save() {
    if (typeof client_id == 'number') payload.client_id = client_id;
    console.log('payload:',payload);

    postData(`${config.defaultURL}/times/add`, payload)
    .catch((error) => console.error('Failed to post time:', error))
    .then((res) => {
      console.log(res)
      closeModal()
    })
  }
</script>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>

<div class="modal" id="timeModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Add Time</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Date</label>
            <input bind:value={payload.date} type="date" class="input" name="date" placeholder="Date Of time" />
          </div>          
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Minutes</label>
            <input bind:value={payload.minutes} type="number" class="input" name="minutes" placeholder="time minutes" />
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Description</label>
            <input bind:value={payload.description} type="text" class="input" name="description" placeholder="time Description" />
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Category</label>
            <input list="categories" class="input" name="Category" placeholder="time Category (optional)" bind:value={payload.category} />
            <datalist id="categories">
              {#each categoryOptions as category}
              <option>{category}</option>
              {/each}
            </datalist>          
          </div>
        </div>
        <div class="column">
          <div class="field">
            <!-- svelte-ignore a11y-label-has-associated-control -->
            <label class="label">Client</label>
            <div class="select">
              <select bind:value={client_id} name="client_id">
                <option value=null>Select Client</option>
                {#each clientOptions as opt}
                <option value={opt.id}>{opt.first} {opt.last}</option>
                {/each}
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button on:click={save} class="button is-primary">Submit</button>
        </div>
        <div class="control">
          <button
            on:click={closeModal}
            class="button is-primary is-light">Cancel</button>
        </div>
      </div>
    </section>
  </div>
</div>
